var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("report-filters", {
        attrs: {
          selectedLegalEntity: _vm.selectedLegalEntity,
          startDate: _vm.startDate,
          endDate: _vm.endDate,
          loading: _vm.loading,
          hasData: _vm.reportData && _vm.reportData.length > 0,
          reportType: "response_time"
        },
        on: {
          "update:selectedLegalEntity": function($event) {
            _vm.selectedLegalEntity = $event
          },
          "update:selected-legal-entity": function($event) {
            _vm.selectedLegalEntity = $event
          },
          "update:startDate": function($event) {
            _vm.startDate = $event
          },
          "update:start-date": function($event) {
            _vm.startDate = $event
          },
          "update:endDate": function($event) {
            _vm.endDate = $event
          },
          "update:end-date": function($event) {
            _vm.endDate = $event
          },
          search: _vm.loadReportData,
          clear: _vm.clearFilters,
          export: _vm.exportToPdf
        },
        scopedSlots: _vm._u([
          {
            key: "additional-filters",
            fn: function() {
              return [
                _c(
                  "b-row",
                  { staticClass: "mt-2" },
                  [
                    _c(
                      "b-col",
                      { attrs: { cols: "12", md: "3" } },
                      [
                        _c(
                          "b-form-group",
                          {
                            attrs: {
                              label: _vm.$t(
                                "reporting_channel.reports.response_time.filters.protocol_number"
                              )
                            }
                          },
                          [
                            _c("b-form-input", {
                              attrs: {
                                placeholder: _vm.$t(
                                  "reporting_channel.reports.response_time.filters.protocol_number_placeholder"
                                ),
                                type: "text"
                              },
                              model: {
                                value: _vm.protocolNumber,
                                callback: function($$v) {
                                  _vm.protocolNumber = $$v
                                },
                                expression: "protocolNumber"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ]
            },
            proxy: true
          }
        ])
      }),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "b-card",
                [
                  _c("b-card-title", [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "reporting_channel.reports.response_time.history_title"
                        )
                      )
                    )
                  ]),
                  _c(
                    "b-card-body",
                    [
                      !_vm.reportData || _vm.reportData.length === 0
                        ? _c(
                            "b-alert",
                            { attrs: { show: "", variant: "info" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "reporting_channel.reports.response_time.no_data_message"
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          )
                        : _c(
                            "div",
                            _vm._l(_vm.reportData, function(handling) {
                              return _c(
                                "div",
                                {
                                  key: handling.handling_id,
                                  staticClass: "mb-4"
                                },
                                [
                                  _c(
                                    "b-card",
                                    { staticClass: "mb-2 border-primary" },
                                    [
                                      _c(
                                        "b-card-body",
                                        [
                                          _c(
                                            "b-row",
                                            {
                                              staticClass: "align-items-center"
                                            },
                                            [
                                              _c(
                                                "b-col",
                                                {
                                                  attrs: { cols: "12", md: "6" }
                                                },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "d-flex align-items-center"
                                                    },
                                                    [
                                                      _c("feather-icon", {
                                                        staticClass:
                                                          "mr-2 text-primary",
                                                        attrs: {
                                                          icon: "FileTextIcon",
                                                          size: "20"
                                                        }
                                                      }),
                                                      _c("div", [
                                                        _c(
                                                          "h5",
                                                          {
                                                            staticClass: "mb-0"
                                                          },
                                                          [
                                                            _c(
                                                              "strong",
                                                              {
                                                                staticClass:
                                                                  "text-primary"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "reporting_channel.reports.response_time.protocol"
                                                                    )
                                                                  ) +
                                                                    ": " +
                                                                    _vm._s(
                                                                      handling.protocol_number ||
                                                                        "-"
                                                                    )
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        ),
                                                        _c(
                                                          "small",
                                                          {
                                                            staticClass:
                                                              "text-muted"
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "reporting_channel.reports.response_time.handling_id"
                                                                )
                                                              ) +
                                                                ": " +
                                                                _vm._s(
                                                                  handling.handling_id
                                                                )
                                                            )
                                                          ]
                                                        )
                                                      ])
                                                    ],
                                                    1
                                                  )
                                                ]
                                              ),
                                              _c(
                                                "b-col",
                                                {
                                                  staticClass: "mt-2 mt-md-0",
                                                  attrs: { cols: "12", md: "6" }
                                                },
                                                [
                                                  handling.legal_entity
                                                    ? _c("div", [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "d-flex align-items-center"
                                                          },
                                                          [
                                                            _c("feather-icon", {
                                                              staticClass:
                                                                "mr-2 text-secondary",
                                                              attrs: {
                                                                icon:
                                                                  "BuildingIcon",
                                                                size: "18"
                                                              }
                                                            }),
                                                            _c("div", [
                                                              _c(
                                                                "strong",
                                                                {
                                                                  staticClass:
                                                                    "text-dark"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      handling
                                                                        .legal_entity
                                                                        .company_name ||
                                                                        "-"
                                                                    )
                                                                  )
                                                                ]
                                                              ),
                                                              handling
                                                                .legal_entity
                                                                .trading_name
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "text-muted small"
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        " " +
                                                                          _vm._s(
                                                                            handling
                                                                              .legal_entity
                                                                              .trading_name
                                                                          ) +
                                                                          " "
                                                                      )
                                                                    ]
                                                                  )
                                                                : _vm._e()
                                                            ])
                                                          ],
                                                          1
                                                        )
                                                      ])
                                                    : _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "text-muted"
                                                        },
                                                        [
                                                          _c("small", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.$t(
                                                                  "reporting_channel.reports.response_time.institution_not_informed"
                                                                )
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                ]
                                              )
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  ),
                                  _c("b-table", {
                                    staticClass: "mb-0",
                                    attrs: {
                                      items: handling.history,
                                      fields: _vm.tableFields,
                                      striped: "",
                                      hover: "",
                                      responsive: "",
                                      small: "",
                                      "tbody-tr-class": "history-row"
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "cell(status_str)",
                                          fn: function(row) {
                                            return [
                                              _c("HandlingStatusBadge", {
                                                attrs: {
                                                  label:
                                                    row.item.status_str || "-",
                                                  color:
                                                    (row.item.status_obj &&
                                                      row.item.status_obj
                                                        .color) ||
                                                    row.item.status_color ||
                                                    null
                                                }
                                              })
                                            ]
                                          }
                                        },
                                        {
                                          key: "cell(created_date_formatted)",
                                          fn: function(row) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    row.item
                                                      .created_date_formatted ||
                                                      (row.item.created_at
                                                        ? this.$utils.format.date(
                                                            row.item.created_at,
                                                            false
                                                          )
                                                        : "-")
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          }
                                        },
                                        {
                                          key: "cell(time_in_status_formatted)",
                                          fn: function(ref) {
                                            var item = ref.item
                                            var value = ref.value
                                            return [
                                              item.status === "CL"
                                                ? _c("div", [
                                                    handling.total_time_in_status_formatted &&
                                                    handling.total_time_in_status_formatted !==
                                                      "Menos de 1 hora"
                                                      ? _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "text-primary"
                                                          },
                                                          [
                                                            _c("strong", [
                                                              _vm._v(
                                                                "Tempo total:"
                                                              )
                                                            ]),
                                                            _vm._v(
                                                              " " +
                                                                _vm._s(
                                                                  handling.total_time_in_status_formatted
                                                                ) +
                                                                " "
                                                            )
                                                          ]
                                                        )
                                                      : _vm._e()
                                                  ])
                                                : _c("div", [
                                                    _c(
                                                      "strong",
                                                      {
                                                        staticClass:
                                                          "text-primary"
                                                      },
                                                      [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              value || "-"
                                                            ) +
                                                            " "
                                                        )
                                                      ]
                                                    )
                                                  ])
                                            ]
                                          }
                                        },
                                        {
                                          key: "cell(user)",
                                          fn: function(row) {
                                            return [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    row.item.user &&
                                                      row.item.user.name
                                                      ? row.item.user.name
                                                      : "-"
                                                  ) +
                                                  " "
                                              )
                                            ]
                                          }
                                        }
                                      ],
                                      null,
                                      true
                                    )
                                  })
                                ],
                                1
                              )
                            }),
                            0
                          )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }